import { render, staticRenderFns } from "./RequestCardTablet.vue?vue&type=template&id=18fc887f&lang=pug&"
import script from "./RequestCardTablet.vue?vue&type=script&lang=js&"
export * from "./RequestCardTablet.vue?vue&type=script&lang=js&"
import style0 from "./RequestCardTablet.vue?vue&type=style&index=0&id=18fc887f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports